export default __webpack_public_path__ + "static/media/Chimie.f2a3a9b9.gif";